import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Link, Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import {
  BodyWrapper,
  Header,
  Loader,
  MainWrapper,
  SidebarWrapper,
} from '@components';
import { ArrowLeftIcon } from '@svgs';
import { businessQuery, locationQuery, sitesQuery } from '@queries';

import { LocationBreadcrumbs } from '../components/LocationBreadcrumbs/LocationBreadcrumbs.jsx';
import { LocationSidebar } from '../components/LocationSidebar/LocationSidebar.jsx';

export const Location = () => {
  const { t, i18n } = useTranslation();
  const { businessID, locationID } = useParams();

  // Fetches business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // Fetches business
  const { data: locationData, isPending: locationIsPending } = useQuery(
    locationQuery(locationID),
  );

  // Fetch sites
  const {
    data: sitesData,
    isPending: sitesIsPending,
    isError,
  } = useQuery(
    sitesQuery({
      business_id: businessID,
      location_id: locationID,
      limit: 1,
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <SidebarWrapper>
          <div className="sb-sidebar-nav">
            <div className="sb-sidebar-header">
              <Link
                to={`/dashboard/projects/${businessID}/locations`}
                className="sb-sidebar-back-btn sb-flex"
              >
                <ArrowLeftIcon />
                Back to Project
              </Link>
            </div>
          </div>
        </SidebarWrapper>
        <MainWrapper>
          <LocationBreadcrumbs
            businessData={businessData}
            locationData={locationData}
          >
            <li className="sb-flex">
              <span>...</span>
            </li>
          </LocationBreadcrumbs>
          <div className="sb-websites">
            <h1>...</h1>
            {sitesIsPending && <Loader className="sb-loader sb-loader-large" />}
            {!sitesIsPending && (isError || sitesData.objects?.length == 0) && (
              <Navigate
                to={`/dashboard/projects/${businessID}/locations/${locationID}/location_details`}
                replace
              />
            )}
            {!sitesIsPending && !isError && sitesData.objects?.length > 0 && (
              <Navigate
                to={`/dashboard/sites/${sitesData.objects[0].id}/location_details`}
                replace
              />
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
